import { Box, Collapse, IconButton, Paper, Table, TableBody, TableContainer, TableCell, TableHead, TableRow, TextField, Typography, useTheme, ListItemButton, Menu, MenuItem, TablePagination, TableSortLabel, Skeleton, InputAdornment, Theme, SxProps, alpha } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import CustomDropdown from '../../../lib/formik/CustomDropdown'
import { ActionIcon, DarkSearchIcons, DialogCloseIcon, DropDownIcons, ExportIcon, SearchIcon, SideDropDownIcon } from '../../../assets/SvgIcons'
import IconCustomeDropDown from '../../../lib/formik/IconsCustomeDropDown';
import { useHistory } from 'react-router';
import { off } from 'process';
import { formatCurrency, getModeOfHoldingDisplay, isModuleAllowed, maskInfo, toINR } from '../../../utils/utilityFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { setClientCode } from '../../../redux-store/actions/investorProfile';
import _ from 'lodash';
import { storeSelectedPortfolio } from '../../../redux-store/actions/portfolioFilter';
import { getAccountsExportData } from '../../../redux-store/actions/userManagement';
import { reportDownload } from '../../Reports/report-utils';
import { useSnackbar } from 'notistack';
import { RootStateType } from '../../../redux-store/reducers';
import SwitchSelection from '../../../lib/formik/SwitchSelection';
import { theme } from 'highcharts';
import { ROLE_GROUP} from '../../../utils/constant';

// const TableCell = styled(MuiTableCell)({
//     width: '50px',
//     // background: 'red'
// })


const filter = [
    {
        "label": "By Individual",
        "value": 1
    },
    {
        "label": "By Family",
        "value": 2
    }
]

interface AccountProps {
    isLoading: boolean
    accountTable: {
        individual: Array<RowProps>,
        family: Array<RowProps>
    },
    aumAmount: number,
    error: boolean,
    exportData: any;
}

export interface RowProps {
    familyName?: string,
    customerName?: string,
    portfolioName?: string,
    name?: string,
    // portfolioName: string,
    child?: boolean,
    list?: Array<RowProps>,
    ofBook?: number,
    investedValue?: number,
    marketValue?: number,
    unrealised?: number,
    unrealisedPercentage?: number,
    cash?: number,
    irr?: number,
    id?: number,
    clickable?: boolean,
    family?: boolean,
    clientCode?: string,
    portfoiloId?: string,
    familyCode?: string,
    isPortfolioHeldaway?: boolean,
    accountType?: string;
    modeOfHolding?: string;
    riskProfileId?: string;
    trailAssetsAUM?: number;
    rmName?: string;
    uccCode?: string;
}

interface Sorting { name: string, order: "asc" | "desc" | undefined }


export default function Account(props: AccountProps) {
    const { isLoading, accountTable, aumAmount, error, exportData } = props
    const { palette } = useTheme()
    const { enqueueSnackbar } = useSnackbar();
    const history = useHistory()
    const state = history.location.state as { accountFilter?: number }
    const { roleGroup = '', isBaseRM  } = useSelector((store: RootStateType) => store.auth);


    const [filterValue, setFilterValue] = useState<number | string>(state?.accountFilter || filter[0].value)
    const [tableData, setTableData] = useState<any[]>([])
    const [rowOption, setRowOption] = useState<number>(5)
    const [rowArray, setRowArray] = useState<number[]>([])
    const [currentPage, setCurrentPage] = useState<number>(0)
    const [searchInput, setSearchInput] = useState<string>('');
    const [exportLoad, setExportLoad] = useState<boolean>(false);
    const [sorting, setSorting] = useState<Sorting>({
        name: '',
        order: 'asc',
    })
    const dispatch = useDispatch();
    const style: SxProps = { fontWeight: 500, fontSize: '14px', textTransform: 'capitalize', textWrap: 'nowrap', paddingRight: 0, paddingLeft: 0 }

    useEffect(() => {
        const dummy = tableData?.length <= 5 ? [5] : tableData?.length <= 10 ? [5, 10] : tableData?.length <= 15 ? [5, 10, 15] : [5, 10, 15, 20]
        setRowArray(dummy)
    }, [tableData])


    useEffect(() => {
        const dummy = [...((filterValue === 1 ? accountTable?.individual : accountTable?.family) || [])]
        setTableData(dummy)
    }, [filterValue, accountTable])

    const isRMRGroup = [ROLE_GROUP.RMR].includes(roleGroup);

    const handlePageChange = (event: any, page: number) => {
        setCurrentPage(page);
    }

    const handleRow = (row: string | number) => {
        setRowOption(parseInt(row as string))
        setCurrentPage(0)
        setSearchInput('')
    }

    const handleSorting = (name: string) => {
        setCurrentPage(0)

        setSorting((preSorting) => {
            const preNameSort = preSorting.name === name;

            return { name: name, order: preNameSort ? (preSorting.order === 'asc' ? 'desc' : 'asc') : preSorting.order }
        })
    }

    const handleSearch = (value: string) => {
        setCurrentPage(0)
        setRowOption(5)
        setSearchInput(value)
    }

    const handleCancelSearch = () => {
        setCurrentPage(0)
        setRowOption(5)
        setSearchInput('')
    }

    const handleExport = async () => {
        setExportLoad(true)
        try {
            const formatExportedData = [
                {
                    "navDate": "NAV DATE",
                    "familyName": "FAMILY NAME",
                    "customer": "CUSTOMER",
                    "customerName": "CUSTOMER NAME",
                    "activationDate": "ACTIVATION DATE",
                    "portfolio": "PORTFOLIO",
                    "portfolioName": "PORTFOLIO NAME",
                    "startDate": "START DATE",
                    "netAssets": "NET ASSETS",
                    "capital": "CAPITAL",
                    "cashBalance": "CASH BALANCE",
                    "cashflow": "CASH FLOW",
                    "unrelGainLoss": "UNREALISED GAIN LOSS",
                    "return": "RETURN",
                    "WtAvgDays": "WT. AVG DAYS",
                    "isPfInvestExists": "IS PF INVEST EXISTS",
                    "modeOfHolding": 'MODE OF HOLDING',
                    "cusAccountType": "CUS ACCOUNT TYPE",
                    "riskProfileId": "RISK PROFILE ID",
                    "relationManagerName": "RM NAME",
                    "trailAssetsAUM": "TRAIL ASSETS AUM",
                },
                ...exportData
            ]
            const exportRes = (await dispatch(getAccountsExportData({ jsonData: formatExportedData, sheetName: 'Investor Basic Investment Details',isPDF:true }))) as unknown as any;
            reportDownload(exportRes as unknown as Blob, 'Investor Basic Investment Details.xlsx');
            enqueueSnackbar('File downloaded successfully.', {
                variant: 'success',
                autoHideDuration: 2000,
            });

        } catch (err) {
            console.log('err', err)
            enqueueSnackbar('File download failed!.', {
                variant: 'error',
                autoHideDuration: 2000,
            });
        }
        setExportLoad(false)
    }

    const handleAssetOptionChange = (value: string | number) => {
        setFilterValue(value);
    }

    return (
        <>
            <Box component={'section'} style={{
                width: '100%',
                padding: '25px 30px',
                // borderRadius: 20,
                // background: '#ffffff',
                // boxShadow: `0px 4px 10px 0px ${palette.background.default}`,
                // border: `3px solid ${palette.stroke.main}`,
                // backgroundColor: palette.grey.A100,
                border: '10px',
                background: palette.common.white,
                marginTop: '15px'
            }}>
                <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%', alignItems: 'center', flexWrap: { lg: 'nowrap', md: 'nowrap', sm: 'wrap', xs: 'wrap' }, rowGap: '20px' }}>
                    <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', gap: '25px', alignItems: 'center', justifyContent: { lg: 'flex-start', md: 'flex-start', sm: 'space-between', xs: 'space-between' }, width: '100%' }}>
                        <Typography variant='h2' color={palette.common.black}>
                            Account
                        </Typography>
                    </Box>
                    <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', gap: '25px', alignItems: 'center', justifyContent: { lg: 'flex-end', md: 'flex-end', sm: 'space-between', xs: 'space-between' }, width: '100%' }}>
                        <IconButton sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            gap: '5px',
                            alignItems: 'center',
                            padding: '2px 0px',
                            cursor: 'pointer',
                            "&:hover": { backgroundColor: "transparent" }

                        }}
                            disableFocusRipple={true}
                            onClick={exportLoad ? () => null : () => handleExport()}
                        >
                            <ExportIcon />
                            <Typography variant="body_400" color={palette.common.black}>Export</Typography>
                        </IconButton>
                        {/* <CustomDropdown IsLoading={isLoading} options={filter} defaultValue={state?.accountFilter || filter[0].value} setFilterValue={setFilterValue} /> */}
                        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: '10px', alignItems: { xs: 'flex-end', md: 'center' }, justifyContent: { lg: 'flex-end', md: 'flex-end', sm: 'space-between', xs: 'space-between' }, width: '100%' }}>
                            <SwitchSelection value={filterValue} handleOptionChange={handleAssetOptionChange} options={filter as { label: string; value: number | string; }[]} />

                            <TextField
                                // autoFocus
                                // fullWidth
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <DarkSearchIcons />
                                        </InputAdornment>
                                    ),
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                sx={{
                                                    display: searchInput.length > 0 ? 'inline-flex' : 'none',
                                                }}
                                                onClick={handleCancelSearch}
                                            >
                                                <DialogCloseIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                    sx: (theme: Theme) => ({
                                        borderRadius: '55px',
                                        // height: '47.17px',
                                        height: '40px',
                                        border: `1px solid ${theme.palette.text.secondary}B2`,
                                        // marginTop: '20px',
                                        // width: '100%',
                                        maxWidth: '204px',
                                        padding: '10px 12px',
                                        '& fieldset': {
                                            border: 'none',
                                        },
                                        '& input': {
                                            paddingLeft: '10px',
                                            ...theme.typography.subtitle_600,
                                            fontWeight: 400,
                                            color: theme.palette.text.primary,
                                            '&:placeholder': {
                                                ...theme.typography.subtitle_600,
                                                fontWeight: 400,
                                                color: theme.palette.text.secondary,
                                                opacity: 1,
                                            },
                                        },
                                    }),
                                }}
                                placeholder="Search"
                                value={searchInput}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    handleSearch(event.target.value);
                                }}
                            />

                        </Box>
                    </Box>
                </Box>

                <TableContainer sx={{ mt: '40px' }}>
                    <Table aria-label="collapsible table" style={{ tableLayout: "auto" }}>
                        <TableHead sx={{ display: "table-header-group" }}>
                            <TableRow >
                                <TableCell sx={{ ...style, paddingLeft: '15px', minWidth: '180px' }} >
                                    <TableSortLabel active={(filterValue === 1 ? 'customerName' : 'familyName') === sorting.name}
                                        color={palette.common.black}
                                        direction={sorting.order}
                                        onClick={() => handleSorting(filterValue === 1 ? 'customerName' : 'familyName')}>Name</TableSortLabel>
                                </TableCell>
                                {filterValue === 1 ?
                                    <TableCell align='center' sx={{ ...style }}>
                                        <TableSortLabel active={'accountType' === sorting.name}
                                            color={palette.common.black}
                                            direction={sorting.order}
                                            onClick={() => handleSorting('accountType')}>Account Type</TableSortLabel>
                                    </TableCell> : null
                                }
                                <TableCell align='center' sx={{ ...style }}>
                                    <TableSortLabel active={'modeOfHolding' === sorting.name}
                                        direction={sorting.order}
                                        onClick={() => handleSorting('modeOfHolding')}>Mode of Holding</TableSortLabel>
                                </TableCell>
                                {!isBaseRM  && <TableCell align='center' sx={{ ...style, paddingRight: 2 }}>
                                    Tagged RM
                                </TableCell>}
                                <TableCell align='center' sx={{ ...style }}>
                                    <TableSortLabel active={'investedValue' === sorting.name}
                                        direction={sorting.order}
                                        onClick={() => handleSorting('investedValue')}>invested value</TableSortLabel>
                                </TableCell>
                                <TableCell align='center' sx={{ ...style }} >
                                    <TableSortLabel active={'marketValue' === sorting.name}
                                        direction={sorting.order}
                                        onClick={() => handleSorting('marketValue')}>market value</TableSortLabel>
                                </TableCell>
                                <TableCell align='center' sx={{ ...style }}>
                                    <TableSortLabel active={'trailAssetsAUM' === sorting.name}
                                        direction={sorting.order}
                                        onClick={() => handleSorting('trailAssetsAUM')}>Trail Assets AUM</TableSortLabel>
                                </TableCell>
                                <TableCell align='center' sx={{ ...style }} >
                                    <TableSortLabel active={'unrealised' === sorting.name}
                                        direction={sorting.order}
                                        onClick={() => handleSorting('unrealised')}>unrealised return</TableSortLabel>
                                </TableCell>
                                <TableCell align='center' sx={{ ...style }} >
                                    <TableSortLabel active={'riskProfileId' === sorting.name}
                                        direction={sorting.order}
                                        onClick={() => handleSorting('riskProfileId')}>
                                        Risk Profile
                                    </TableSortLabel>
                                </TableCell>
                                <TableCell align='center' sx={{ ...style }} >
                                    <TableSortLabel active={'irr' === sorting.name}
                                        direction={sorting.order}
                                        onClick={() => handleSorting('irr')}>Absolute Return %</TableSortLabel>
                                </TableCell>
                                {/* <TableCell align='center' sx={{ ...style }} >actions</TableCell> */}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {isLoading ? <TableLoader row={5} column={10} /> : null}
                            {error ?
                                <TableRow>
                                    <TableCell colSpan={9}>
                                        <Typography sx={{ textAlign: 'center' }} variant='h2' color={'text.primary'}>No data found</Typography>
                                    </TableCell>
                                </TableRow> : null
                            }
                            {!error ?
                                <>
                                    {(_.orderBy(tableData, [sorting.name], [sorting.order ? sorting.order : 'desc']).filter((row) => filterValue === 1 ? row.customerName?.toLowerCase().includes(searchInput?.toLowerCase()) : row.familyName?.toLowerCase().includes(searchInput?.toLowerCase())).sort((a, b) => sorting.order === 'desc' ? (a[sorting.name] - b[sorting.name]) : (b[sorting.name] - a[sorting.name])).slice((currentPage) * rowOption, ((currentPage) * rowOption) + rowOption)).map((row, i) => (
                                        <Row key={i + row?.portfolioName} row={row} border={false} child={false} right={false} filterValue={filterValue as any} aumAmount={aumAmount} isBaseRM ={isBaseRM } />
                                    ))}
                                    {!isLoading && (_.orderBy(tableData, [sorting.name], [sorting.order ? sorting.order : 'desc']).filter((row) => filterValue === 1 ? row.customerName?.toLowerCase().includes(searchInput?.toLowerCase()) : row.familyName?.toLowerCase().includes(searchInput?.toLowerCase())).sort((a, b) => sorting.order === 'desc' ? (a[sorting.name] - b[sorting.name]) : (b[sorting.name] - a[sorting.name])).slice((currentPage) * rowOption, ((currentPage) * rowOption) + rowOption)).length === 0 ?
                                        <TableRow>
                                            <TableCell colSpan={8}>
                                                <Typography sx={{ textAlign: 'center' }} variant='h2' color={'text.primary'}>No data found</Typography>
                                            </TableCell>
                                        </TableRow> : null
                                    }
                                </> : null
                            }
                        </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={rowArray}
                        component="div"
                        count={_.orderBy(tableData, [sorting.name], [sorting.order ? sorting.order : 'desc']).filter((row) => filterValue === 1 ? row.customerName?.toLowerCase().includes(searchInput?.toLowerCase()) : row.familyName?.toLowerCase().includes(searchInput?.toLowerCase())).length}
                        rowsPerPage={rowOption}
                        page={currentPage}
                        labelRowsPerPage={"Rows per page:"}
                        onPageChange={handlePageChange}
                        onRowsPerPageChange={(e) => handleRow(e.target.value)}
                        sx={{
                            color: palette.text.primary[500]
                        }} />
                </TableContainer>
            </Box >
        </>
    )
}



function Row(props: { row: RowProps | undefined, border?: boolean, child: boolean, right?: boolean, clickable?: boolean | undefined, filterValue: number, aumAmount: number, isBaseRM ?: boolean }) {
    const { row, border, child, right, clickable, filterValue, aumAmount, isBaseRM  } = props;
    const [open, setOpen] = React.useState(false);
    const { palette } = useTheme()
    const history = useHistory()
    const dispatch = useDispatch()

    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);
    const { permissions, roleGroup  } = useSelector((store: RootStateType) => store.auth);

    const style = { fontWeight: 400, padding: 0 }



    const handleClick = () => {
        if ([ROLE_GROUP.RSP].includes(roleGroup)) return;

        dispatch(setClientCode((row?.clientCode || "") as string))
        dispatch(storeSelectedPortfolio({ label: '', value: '' }))

        if (filterValue === 1) {
            if (isModuleAllowed({ value: "INVDashboard", compareArr: permissions, objKey: "permissonCode" })) {
                history.push(`/investor-profile/${row?.customerName}`, {
                    clientCode: (row?.clientCode || "") as string,
                    portfoiloId: row?.portfoiloId || "",
                    accountFilter: filterValue,
                    accountType: row?.accountType,
                    uccCode: row?.uccCode,
                })
            }
        } else if (filterValue === 2) {
            if (!child) {
                history.push(`/family-profile/${(maskInfo(row?.familyName || ""))}`, {
                    familyName: (row?.familyName || "") as string,
                    accountFilter: filterValue
                })
            } else {
                if (isModuleAllowed({ value: "INVDashboard", compareArr: permissions, objKey: "permissonCode" })) {
                    history.push(`/investor-profile/${row?.customerName}`, {
                        clientCode: (row?.clientCode || "") as string,
                        portfoiloId: row?.portfoiloId || "",
                        accountFilter: filterValue,
                        accountType: row?.accountType,
                        uccCode: row?.uccCode,
                    })
                }
            }
        }
        // }
    }

    return (
        <>
            <TableRow style={{
                borderLeft: (child || open) ? `3px solid ${palette.primary[500]}` : '3px solid transparent',
                // padding: border ? '10px 0px' : '0px',
                // margin: border ? '10px 0px' : '0px',
                // background: 'red'
            }}>
                <TableCell
                    onClick={(e) => (filterValue === 2 && !child && row?.familyName === 'not applicable') ? null : handleClick()}
                    component="th" scope="row" sx={{
                        opacity: (filterValue === 2 && !child && row?.familyName === 'not applicable') ? 0.5 : 1,
                        padding: right ? '16px 30px' : '16px 8px',
                        // color: palette.primary[500],
                        fontWeight: 500,
                        textTransform: 'capitalize',
                        cursor: 'pointer',
                        flex: 'display',
                        flexDirection: 'row',
                        minWidth: '180px'
                    }}>
                    {row?.child &&
                        <IconButton
                            aria-label="expand row"
                            size="small"
                            onClick={(e) => {
                                e.stopPropagation()
                                setOpen(!open)
                            }}
                        >
                            {!open ? <SideDropDownIcon /> : <DropDownIcons />}
                        </IconButton>
                    }
                    {/* {!row?.child && <IconButton size='small' sx={{ backgroundColor: 'transparent', }} disableRipple={true} >
                        <SideDropDownIcon opacity={10} style={{ opacity: 0 }} />
                    </IconButton>} */}
                    {child ?
                        (row?.list?.length as number) > 0 ?
                            row?.customerName?.toLowerCase()
                            : maskInfo(row?.portfolioName || '')?.toLowerCase()
                        : filterValue === 1 ?
                            row?.customerName?.toLowerCase()
                            : row?.familyName === 'Not Applicable' ?
                                row?.customerName?.toLowerCase()
                                : maskInfo((row?.familyName || '')?.toLowerCase())} {`${(row?.list?.length as number) > 0 ? `(${row?.list?.length})` : ''}`}
                </TableCell>
                {filterValue === 1 ?
                    <TableCell align="center" style={{ ...style }}>
                        {row?.accountType ?? "-"}
                    </TableCell> : null
                }
                <TableCell align="center" style={{ ...style }}>
                    {getModeOfHoldingDisplay(row?.modeOfHolding || "") ?? "-"}
                </TableCell>
                {!isBaseRM  && <TableCell align="center" style={{ ...style, paddingRight: 2 }}>
                    {row?.rmName ?? '-'}
                </TableCell>}
                <TableCell align="center" style={{ ...style }}>
                    {row?.investedValue as number < 0 ? `- ${formatCurrency({ value: Math.abs(row?.investedValue ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: row?.investedValue ?? 0, locale, currencyCode })}`}
                </TableCell>
                <TableCell align="center" style={{ ...style }}>
                    {row?.marketValue as number < 0 ? `- ${formatCurrency({ value: Math.abs(row?.marketValue ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: (row?.marketValue ?? 0), locale, currencyCode })}`}
                </TableCell>
                <TableCell align="center" style={{ ...style }}>
                    {row?.trailAssetsAUM as number < 0 ? `- ${formatCurrency({ value: Math.abs(row?.trailAssetsAUM ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: (row?.trailAssetsAUM ?? 0), locale, currencyCode })}`}
                </TableCell>
                <TableCell align="center" style={{ ...style, color: (row?.unrealised as number) < 0 ? palette.error[500] : palette.success[500] }}>{row?.unrealised as number >= 0 ? '' : '-'}{formatCurrency({ value: Math.abs(row?.unrealised as number), locale, currencyCode })}</TableCell>
                <TableCell align="center" style={{ ...style }}>
                    {row?.riskProfileId ?? '-'}
                </TableCell>
                <TableCell align="center" style={{ ...style, color: (row?.irr as number) < 0 ? palette.error[500] : palette.success[500] }}>{row?.irr?.toFixed(2)}</TableCell>
                {/* <TableCell align="center" style={{ ...style }}>
                    <IconCustomeDropDown data={row} filterValue={filterValue} isToggle={child} />
                </TableCell> */}
            </TableRow >
            {(row?.child && open) &&
                row?.list?.map((item, i) => (
                    <Row key={i} row={item} border={false} child={true} right={true} filterValue={filterValue} aumAmount={aumAmount} isBaseRM={isBaseRM} />
                ))
            }
        </>
    );
}


function TableLoader(props: { row: number, column: number }) {
    const { row = 5, column = 8 } = props
    return (
        <>
            {[...Array(row)].map((_, index) => (
                <TableRow key={index} sx={{ '& > *': { borderBottom: 'unset' } }} style={{
                    borderLeft: 'none',
                    padding: '0px',
                    margin: '0px',
                    transitionTimingFunction: 'ease-in'
                }}>

                    {[...Array(column)].map((_, index) => (

                        <TableCell
                            key={index}
                            component="th"
                            scope="row"
                            style={{
                                padding: '0px 8px',
                                color: 'transparent',
                                fontWeight: 500,
                                textTransform: 'capitalize',
                                cursor: 'pointer'
                            }}
                        >
                            <Skeleton
                                variant="text"
                                animation="wave"
                                sx={{
                                    padding: '10px 0px',
                                    borderRadius: "7px"
                                }}
                            />
                        </TableCell>
                    ))}

                </TableRow>
            ))}
        </>
    )
}